import { type FC } from 'react';
import cx from 'classnames';
import styles from './MenuOverlay.module.css';

type MenuProgressHeaderProps = {
  title: string;
  /** Pre-formatted percent string ("43%") or a placeholder ("—"). */
  percentLabel: string;
  /** 0..100 — drives the fill width. */
  percent: number;
  /** "You have explored 6 out of 10 locations". */
  caption: string;
  hasData: boolean;
};

export const MenuProgressHeader: FC<MenuProgressHeaderProps> = ({
  title,
  percentLabel,
  percent,
  caption,
  hasData,
}) => (
  <section className={styles.progressCard}>
    <p className={styles.progressTitle} dir="auto">
      {title}
    </p>
    <div className={styles.progressBlock}>
      <p className={styles.progressPercent}>{percentLabel}</p>
      <div className={styles.progressTrack}>
        <div
          className={styles.progressFill}
          style={{ width: hasData ? `${percent}%` : '0%' }}
        />
      </div>
    </div>
    <p className={cx(styles.progressCaption, !hasData && styles.progressCaptionMuted)} dir="auto">
      {caption}
    </p>
  </section>
);
